<template>
  <div class="tekenaarsheader">
    <div class="headerleft">
      <div class="ico">
        <img src="../../../assets/sidebar/tekenaars-ico.svg" alt />
      </div>
      <h2 class="header">Tekenaars</h2>
      <SearchfieldWithReset2 :filterOn="tekFilters.name" filterBy="name" />
      <div class="filtertoggle" style="padding-left:24px;padding-top:5px">
        <ToggleButton
          :value="showTekFilters"
          @change="toggleShowTekFilters"
          :width="40"
          color="#3076EA"
        />
        <span v-if="showTekFilters == false" class="filter">Filters</span>
        <span v-if="showTekFilters" class="filter" style="color:#3076EA;"
          >Filters</span
        >
      </div>
      <div class="filtertoggle" style="padding-left:24px;padding-top:5px">
        <ToggleButton
          :value="showNewProfiles"
          @change="showNewProfiles = !showNewProfiles"
          :width="40"
          color="green"
        />
        <span v-if="!showNewProfiles" class="filter">Nieuwe lijst</span>
        <span v-else class="filter" style="color:green;"
          >Nieuwe lijst</span
        >
      </div>
    </div>

    <button @click="$emit('showVoegTekenaarToeModal')">
      + Voeg tekenaar toe
    </button>
  </div>
</template>

<script>
import store from "@/store";
import SearchfieldWithReset2 from "./SearchfieldWithReset2";

export default {
  name: "TekenaarsHeader",
  components: {
    SearchfieldWithReset2
  },
  computed: {
    tekFilters() {
      return store.state.tekFilters;
    },
    showTekFilters() {
      return store.state.showTekFilters;
    },
    showNewProfiles: {
      get() {
        return store.state.showNewProfiles
      },
      set(e) {
        store.commit("setShowNewProfiles", e);
      }
    }
  },
  methods: {
    fixupdate(e) {
      store.state.tekFilters.name = e;
    },
    toggleShowTekFilters() {
      store.commit("toggleShowTekFilters", this.showTekFilters);
    }
  }
};
</script>

<style scoped>
.header {
  color: #0b1125;
  opacity: 0.8;
  font-weight: 600;
  padding-right: 30px;
  font-size: 26px;
}
.headerleft {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.ico {
  background-color: #ff9326;
  width: 28px;
  height: 28px;
  border-radius: 5px;
  padding: 4px;
  margin-right: 10px;
}

.tekenaarsheader {
  z-index: 3;
  /* background-color: #FAFCFE; */
  background-color: #eff2f5;
  position: fixed;
  top: 0;
  display: flex;
  width: 100%;
  height: 70px;
  align-items: center;
  justify-content: space-between;
  padding: 50px 40px;
  /* border-bottom: 1px solid #E7E7F3; */
}
.searchbarholder {
  position: relative;
}
.reset-btn {
  position: absolute;
  width: 24px;
  height: 24px;
  top: 8px;
  right: 10px;
  cursor: pointer;
}
.searchfield {
  width: 200px;
  height: 40px;
  background-color: #e4ecfa;
  border-radius: 100px;
  border: none;
  font-size: 14px;
  padding: 10px 10px 10px 14px;
}
.active {
  background-color: #3076ea;
  color: white;
}

button {
  color: #0475f2;
  border: 1px solid #0475f2;
  border-radius: 5px;
  padding: 8px 11px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  background-color: #eff2f5;
  margin-right: 100px;
}
button:hover {
  color: #fff;
  background-color: #0475f2;
}
button:active {
  color: #fff;
  background-color: #1b4d8d;
}
</style>
